module.exports = __webpack_public_path__ + "static/media/codeigniter.68a84657.png";